var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fidelity-campaign-resume" },
    [
      _c(
        "v-list",
        { attrs: { "three-line": "" } },
        [
          _vm._l(_vm.dataContent, function (section, idx) {
            return [
              section.data
                ? _c(
                    "div",
                    { key: idx },
                    [
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-subheader", [_vm._v(_vm._s(section.title))]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "resume-list" },
                        [
                          _vm._l(section.columns, function (column, idx) {
                            return [
                              section.data[column.key]
                                ? _c(
                                    "v-list-tile",
                                    { key: idx, class: column.class },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            { staticClass: "primary--text" },
                                            [_vm._v(_vm._s(column.label))]
                                          ),
                                          _vm._v(" "),
                                          !column.type
                                            ? _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      (column.formatter &&
                                                        column.formatter(
                                                          section.data
                                                        )) ||
                                                        section.data[column.key]
                                                    ) +
                                                    "\n                "
                                                ),
                                              ])
                                            : column.type === "file"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "file-column-container",
                                                },
                                                [
                                                  section.data[column.key]
                                                    ? _c("object", {
                                                        attrs: {
                                                          data: `${
                                                            section.data[
                                                              column.key
                                                            ]
                                                          }#toolbar=0&navpanes=0&scrollbar=0`,
                                                          type: "application/pdf",
                                                          height: "320",
                                                          frameborder: "0",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              )
                                            : column.type === "html"
                                            ? _c("div", [
                                                _c("div", {
                                                  staticClass:
                                                    "html-column-container",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      section.data[column.key]
                                                    ),
                                                  },
                                                }),
                                              ])
                                            : column.type === "list"
                                            ? _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "list-column-container",
                                                  },
                                                  _vm._l(
                                                    section.data[column.key],
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "list-column-item",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(item) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ])
                                            : column.type === "table"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table-column-container",
                                                },
                                                [
                                                  _c("v-data-table", {
                                                    attrs: {
                                                      headers: column.headers,
                                                      items:
                                                        section.data[
                                                          column.key
                                                        ],
                                                      "hide-actions": "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "items",
                                                          fn: function (props) {
                                                            return [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .quantity
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .value
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showActions
        ? _c(
            "div",
            { staticClass: "stepper-footer" },
            [
              _c(
                "v-btn",
                { attrs: { color: "secondary" }, on: { click: _vm.back } },
                [_vm._v("Voltar")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.save } },
                [_vm._v("Salvar")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }